import React, { Component } from 'react';
import _ from 'lodash';
import ShortId from 'shortid';
import { compose } from 'recompose';
import { Card, Loader, Message } from 'semantic-ui-react';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasRESTClient from '../../hocs/has-rest-client';

import TeamMember from '../../components/team-member';

import { authService } from '../../utils/auth-service';

const cardGroupStyle = {
  marginTop: 10,
  marginBottom: 10,
};

class CampaignDashboardTeam extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isLoaded: false,
      pendingInvitations: [],
      members: [],
      users: [],
    };
  }

  componentDidMount() {
    this.loadTeam();
  }

  loadTeam = () => {
    const { jsonAPIClient, restClient, params: { id } } = this.props;
    const { app_metadata: { dyzio: { o_id: organisationId } } } = authService.getProfile();
    jsonAPIClient.get('campaigns', id, {
      include: ['members', 'pendingInvitations'],
    }, (error, response) => {
      const campaign = response.toJSONTree();
      const { members, pendingInvitations } = campaign;
      // Load users
      jsonAPIClient.find('users', { filter: { organisation: organisationId } }, (err, users) => {
        const team = _.map(users, user => user.toJSONTree());
        const notInvitedUsers = _.filter(team, user => {
          const isMember = _.find(members, ['user.id', user.id]);
          const isPending = _.find(pendingInvitations, ['email', user.email]);
          return _.isUndefined(isMember) && _.isUndefined(isPending);
        });
        this.setState({
          users: notInvitedUsers,
          members: _.reject(members, ['role', 'INFLUENCER']),
          pendingInvitations: _.reject(pendingInvitations, ['role', 'INFLUENCER']),
          isLoading: false,
          isLoaded: true,
        });
      });
    });
  }

  deleteMember = () => _.noop();

  inviteMember = (event, data) => {
    const { users } = this.state;
    const { id: userId } = data;
    const { restClient, jsonAPIClient, params: { id: campaignId }, campaign } = this.props;
    const { app_metadata: { dyzio: { o_id: organisationId } } } = authService.getProfile();
    const invitedMember = _.find(users, ['id', userId]);

    const invite = jsonAPIClient.create('campaignInvitation');
    invite.set('name', invitedMember.name);
    invite.set('campaign', {
      type: 'campaigns',
      id: campaignId,
    });
    invite.set('campaignName', campaign.name);
    invite.set('role', invitedMember.role);
    invite.set('status', 'SENT');
    const { origin } = window.location;
    invite.set('link', `${origin}/invite/`);

    if (invitedMember.email) {
      invite.set('email', invitedMember.email);
    }

    if (invitedMember.role === 'INFLUENCER') {
      // this is where we would switch to using IDs
      invite.set('metadata', {
        socialHandle: invitedMember.primarySocialHandle,
        influencerId: invitedMember.id,
      });
    }

    invite.sync()
      .then(ci => {
        const newInvitation = ci.toJSON();
        restClient.post(`/campaigns/${campaignId}/relationships/pendingInvitations/`, {
          data: {
            type: 'campaignInvitation',
            id: newInvitation.id,
          },
        })
        .then(() => {
          this.loadTeam();
        });
      });
  }

  render() {
    const { isLoading, isLoaded, members, pendingInvitations, users } = this.state;
    // console.log(users);
    return (
      <div>
        { isLoading && <Loader active size="big">Loading team...</Loader> }
        {
          isLoaded &&
          <div>
            <h2>Joined</h2>
            { _.isEmpty(members) && <Message content="No records yet." /> }
            {
              !_.isEmpty(members) &&
              <Card.Group itemsPerRow={4} style={cardGroupStyle}>
                { _.map(members, member => <TeamMember
                  buttonClickHandler={this.deleteMember}
                  key={ShortId.generate()}
                  member={member}
                />,
                )}
              </Card.Group>
            }

            <h2>Pending</h2>
            { _.isEmpty(pendingInvitations) && <Message content="No records yet." /> }
            {
              !_.isEmpty(pendingInvitations) &&
              <Card.Group itemsPerRow={4} style={cardGroupStyle}>
                { _.map(pendingInvitations, pendingInvitation => <TeamMember buttonClickHandler={this.deleteMember} key={ShortId.generate()} member={pendingInvitation} />) }
              </Card.Group>
            }

            <h2>Not Invited</h2>
            { _.isEmpty(users) && <Message content="No records yet." /> }
            {
              !_.isEmpty(users) &&
              <Card.Group itemsPerRow={4} style={cardGroupStyle}>
                { _.map(users, user => <TeamMember
                  buttonClickHandler={this.inviteMember}
                  key={ShortId.generate()}
                  buttonLabel="invite"
                  buttonColor="green"
                  buttonIcon="user add"
                  member={user}
                />)
                }
              </Card.Group>
            }
          </div>
        }
      </div>
    );
  }
}

export default compose(
  hasJSONAPIClient,
  hasRESTClient,
)(CampaignDashboardTeam);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-team/index.js
 **/